<template>
    <div :class="this.$style.root" >
        <el-row
          type="flex"
          :gutter="16"
          :style="{flexWrap: 'wrap',marginBottom: '0.5rem',alignItems: 'baseline'}">
          <el-col >
              <h1 :class="this.$style.title">ราคาทองวันนี้ ({{ rec_type }})</h1>
          </el-col>
          <el-col >
              <div :class="this.$style.date">
                {{this.$_datetime_toThaiDatetime(this.date)}}
              </div>
          </el-col>
        </el-row>

        <ul :class="[this.$style.list]">
          <li :class="[this.$style.listitem,this.$style.tracker]">
            <AppTracker :value="this.ornamentBuy" unit="THB">
              <template #label>
                ทองรูปพรรณ
                <br />
                ซื้อเข้า
              </template>
            </AppTracker>
          </li>
          <li :class="[this.$style.listitem,this.$style.tracker]">
          <AppTracker
            :value="this.ornamentSell"
            unit="THB">
            <template slot="label">
              ทองรูปพรรณ
              <br />
              ขายออก
            </template>
          </AppTracker>
        </li>

          <li :class="[this.$style.listitem,this.$style.tracker]">
          <AppTracker :value="this.ingotBuy" unit="THB">
            <template slot="label">
              ทองแท่ง
              <br />
              ซื้อเข้า
            </template>
          </AppTracker>
        </li>

          <li :class="[this.$style.listitem,this.$style.tracker]">
          <AppTracker
            :value="this.ingotSell"
            unit="THB">
            <template slot="label">
              ทองแท่ง
              <br />
              ขายออก
            </template>
          </AppTracker>
        </li>
        </ul>
      </div>
</template>

<script>
//import { mapGetters } from 'vuex'
import datetimeMixin from '@/mixins/datetime'
import { AppTracker } from '@/components/ui/tracker'
//import elementUiStyles from '@/assets/scss/modules/element-ui.module.scss'

import axios from 'axios'
import { AuthService } from '@/services'

export default {
  mixins: [datetimeMixin],
  components: {
     AppTracker
  },
/*   computed: {
    ...mapGetters('goldPrice', [
      'date',
      'ornamentBuy',
      'ornamentSell',
      'ingotBuy',
      'ingotSell',
      'isLoading'
    ])
  }, */
  data() {
    return {
      branchID:0,
      ornamentBuy:0,
      ornamentSell:1,
      ingotBuy:2,
      ingotSell:3,
      goldloaded : false,
      rec_type: '',
      date: new Date(),
    }
  },
/*   created() {
    this.fetch()
  }, */
  mounted() {
      //--get current branch--
      this.meFetch()
  },
  methods: {
    //--- legacy fetch ---
/*     async fetch() {
      try {
        await this.$store.dispatch('goldPrice/fetch')
      } catch (err) {
        this.$notify.error(err.message)
      }
    }, */
    //--- new method ---
    async meFetch() {
      try {
        const {
          data: { result }
        } = await AuthService.getMe()
        const branch = result.branch
        this.branchID = branch.id

      } catch (e) {
         console.log(e)
      } finally {
         const today = new Date()
         const newDate = new Date(today.getTime() - (today.getTimezoneOffset() * 60000));

         await this.goldFetch(this.branchID,newDate)
      }
    },
    async goldFetch(branchID,golddate) {
      //--- Call gold price api from monitor server ---
      const api = axios.create({
          baseURL: process.env.VUE_APP_API_ENDPOINT_M
      })

      const params = `?branch=${branchID}&date=${golddate.toISOString().split('.')[0]}`
      api.get('api/v1/gold_latest/' + params).then(response => {
          //--- get only ingot gold ---
          const gold_recent = response.data.recent_golds
          this.ornamentBuy = parseFloat(gold_recent.ornament_buy)
          this.ornamentSell = parseFloat(gold_recent.ornament_sold)
          this.ingotBuy = parseFloat(gold_recent.ingot_buy)
          this.ingotSell = parseFloat(gold_recent.ingot_sold)
          this.rec_type = gold_recent.type
          this.date = new Date(gold_recent.fromdate)
          this.goldloaded = true
      }).catch(err => {
          console.log(err)
      })
    }
  },
/*
  render() {
    const Trackers = ({ slots }) => (
      <ul class={this.$style.list}>
        {slots().default &&
          slots().default.map(vnode => {
            vnode.data.class = [vnode.data.class, this.$style.tracker]
            return <li class={this.$style.listitem}>{vnode}</li>
          })}
      </ul>
    )

    return (
      <div
        class={this.$style.root}
        {...{ directives: [{ name: 'loading', value: this.isLoading }] }}
        element-loading-background="rgba(0, 0, 0, 0.75)"
        element-loading-custom-class={elementUiStyles.loadingMask}
      >
        <el-row
          type="flex"
          gutter={16}
          style={{
            flexWrap: 'wrap',
            marginBottom: '0.5rem',
            alignItems: 'baseline'
          }}
        >
          <el-col span={null}>
            <h1 class={this.$style.title}>ราคาทองวันนี้</h1>
          </el-col>
          <el-col span={null}>
            <div class={this.$style.date}>
              {this.$_datetime_toThaiDatetime(this.date)}
            </div>
          </el-col>
        </el-row>
        <Trackers>
          <AppTracker value={this.ornamentBuy} unit="THB">
            <template slot="label">
              ทองรูปพรรณ
              <br />
              ซื้อเข้า
            </template>
          </AppTracker>
          <AppTracker
            value={this.ornamentSell}
            unit="THB"
            scopedSlots={{
              value: ({ formattedValue }) => (
                <span style={{ color: '#cc333f' }}>{formattedValue}</span>
              )
            }}
          >
            <template slot="label">
              ทองรูปพรรณ
              <br />
              ขายออก
            </template>
          </AppTracker>
          <AppTracker value={this.ingotBuy} unit="THB">
            <template slot="label">
              ทองแท่ง
              <br />
              ซื้อเข้า
            </template>
          </AppTracker>
          <AppTracker
            value={this.ingotSell}
            unit="THB"
            scopedSlots={{
              value: ({ formattedValue }) => (
                <span style={{ color: '#cc333f' }}>{formattedValue}</span>
              )
            }}
          >
            <template slot="label">
              ทองแท่ง
              <br />
              ขายออก
            </template>
          </AppTracker>
        </Trackers>
      </div>
    )
  }*/
}
</script>

<style lang="scss" module>
.root {
  background-color: #ffe07d;
  color: $--color-text-primary;
  padding: 1rem;
  border-radius: $--border-radius-base;
  box-shadow: $--box-shadow-base;
}

.title {
  margin: 0;
  font-size: 1.125rem;
}

.date {
  font-size: 1.5rem;
  font-weight: bold;
}

.list {
  list-style: none;
  padding: 0;
  margin: 0;
  background-color: white;

  @media (min-width: $--sm) {
    display: flex;
    flex-wrap: wrap;
  }
}

.listitem {
  padding: 0.5rem;

  @media (min-width: $--sm) {
    flex: 1 1 50%;
  }

  @media (min-width: $--md) {
    flex: 1 1 25%;
  }
}

.tracker {
  @media (min-width: $--sm) {
    padding-left: 0.5rem;
    border-left: 0.125rem solid $--border-color-base;
  }
}
</style>
